export const BOOL_OPTIONS = [
  { value: true, label: "Sim" },
  { value: false, label: "Não" }
];

export const LATEST_RUN_OPTIONS = [
  { value: true, label: "Apenas última execução" },
  { value: false, label: "Todas as execuções" }
];

export const CURVA_OPTIONS = [
  { value: "", label: "Sem curva" },
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" }
];
